module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "group",
    class: _vm.colorChng
  }, [_c('input', {
    class: _vm.cclass,
    style: (_vm.cstyle),
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "id": _vm.customid,
      "test-val": _vm.val,
      "required": ""
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        return _vm.validation(_vm.val)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e4f6626","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/Input.vue
// module id = 1696
// module chunks = 6